import { render, staticRenderFns } from "./DirectMessagingChatInput.vue?vue&type=template&id=75ad805f"
import script from "./DirectMessagingChatInput.vue?vue&type=script&lang=ts"
export * from "./DirectMessagingChatInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports